/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetHelpSite200ResponseData
 */
export interface GetHelpSite200ResponseData {
  /**
   * Обфусцированный идентификатор созданного внешнего контакта
   * @type {string}
   * @memberof GetHelpSite200ResponseData
   */
  params?: string
}

/**
 * Check if a given object implements the GetHelpSite200ResponseData interface.
 */
export function instanceOfGetHelpSite200ResponseData(
  value: object
): value is GetHelpSite200ResponseData {
  return true
}

export function GetHelpSite200ResponseDataFromJSON(
  json: any
): GetHelpSite200ResponseData {
  return GetHelpSite200ResponseDataFromJSONTyped(json, false)
}

export function GetHelpSite200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetHelpSite200ResponseData {
  if (json == null) {
    return json
  }
  return {
    params: json['params'] == null ? undefined : json['params'],
  }
}

export function GetHelpSite200ResponseDataToJSON(
  value?: GetHelpSite200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    params: value['params'],
  }
}
